(() => {
  const styles = ['All', 'Modern', 'Natural', 'Statement'];
  const requestedStyle = () => new URL(window.location.href).searchParams.get('lg_style') || 'All';
  const rememberStyle = (style, anchor = false) => {
    const url = new URL(window.location.href);
    if (style === 'All') url.searchParams.delete('lg_style');
    else url.searchParams.set('lg_style', style);
    if (anchor) url.hash = 'lg-selected';
    window.history.replaceState(window.history.state, '', url);
  };
  const setup = (root) => {
    if (!root || root.dataset.lgShoppingReady) return;
    root.dataset.lgShoppingReady = 'true';
    const cards = [...root.querySelectorAll('[data-lg-product]')];
    const filters = [...root.querySelectorAll('[data-lg-filter]')];
    const count = root.querySelector('[data-lg-count]');
    const select = (style) => {
      if (!styles.includes(style)) style = 'All';
      let visible = 0;
      cards.forEach(card => { card.hidden = style !== 'All' && card.dataset.style !== style; if (!card.hidden) visible++; });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lgFilter === style)));
      if (count) count.textContent = `${visible} designs`;
    };
    root._lgSelectDesigns = select;
    select(requestedStyle());
    root.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const filter = event.target.closest('[data-lg-filter]');
      if (filter) {
        select(filter.dataset.lgFilter);
        rememberStyle(filter.dataset.lgFilter);
      }
      const trigger = event.target.closest('[data-lg-open]');
      if (!trigger) return;
      const dialog = document.getElementById(trigger.dataset.lgOpen);
      if (!dialog) return;
      event.preventDefault();
      dialog._lgTrigger = trigger;
      if (!dialog.open) dialog.showModal();
    });
    root.querySelectorAll('.lg-design-dialog').forEach(dialog => {
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => dialog._lgTrigger?.focus());
    });
  };
  document.querySelectorAll('.lg-home').forEach(setup);
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-lg-style-link]');
    const root = document.querySelector('.lg-home');
    if (!link || !root?._lgSelectDesigns) return;
    event.preventDefault();
    const style = styles.includes(link.dataset.lgStyleLink) ? link.dataset.lgStyleLink : 'All';
    root._lgSelectDesigns(style);
    rememberStyle(style, true);
    link.closest('.bb-mobile-nav')?.removeAttribute('open');
    root.querySelector('#lg-selected')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  });
  window.addEventListener('popstate', () => document.querySelector('.lg-home')?._lgSelectDesigns?.(requestedStyle()));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.lg-home').forEach(setup));
})();
